export default __webpack_public_path__ + "static/Logo-674df1f4ecd51fea1f4697bbdd419079.png";